import { injectIntl } from "react-intl";
import type { intlFormatPropTypes } from "react-intl";
import { useSelector } from "react-redux";

import { Item } from "@ps-design-system/components/ItemV2";

import { selectProfileSSOid } from "../../app-main/selectors/profile.selectors";
import { trackTodoItemClicked } from "../analytics/host-hub-analytics";
import {
  PAUSED_LISTING_HELP_URL,
  PAUSED_LISTING_SPACE_NAME_MAX_LENGTH,
} from "../constants/host-hub-paused-listings.consts";
import useHostHubData from "../hooks/useHostHubData";
import { formatListingRowTitle } from "../utils/host-hub-listing.utils";
import { truncateText } from "../utils/host-hub-paused-listing.utils";

type HostHubPausedListingsItemProps = {
  intl: intlFormatPropTypes;
};

const HostHubPausedListingsItem = ({
  intl,
}: HostHubPausedListingsItemProps) => {
  const ssoid = useSelector(selectProfileSSOid);
  const { pausedListings } = useHostHubData();

  const description = intl.formatMessage({
    defaultMessage:
      "Your listing doesn't meet our hosting standards. Learn why and how to unpause.",
    id: "host_hub.todo_list.paused_listing_subtitle",
  });

  return (
    <>
      {pausedListings.items.map(
        ({ id, mediaAlt, mediaUrl, spaceTitle, useType }) => {
          const listingLabel = formatListingRowTitle({
            intl,
            spaceTitle: truncateText(
              spaceTitle,
              PAUSED_LISTING_SPACE_NAME_MAX_LENGTH,
            ),
            useType,
          });
          const title = intl.formatMessage(
            {
              defaultMessage:
                "Your {listing} listing has been paused by Peerspace",
              id: "host_hub.todo_list.paused_listing_title",
            },
            { listing: listingLabel },
          );

          return (
            <Item
              buttonOnClick={() => {
                trackTodoItemClicked({ parameter: "paused_listing", ssoid });
                window.open(
                  PAUSED_LISTING_HELP_URL,
                  "_blank",
                  "noopener,noreferrer",
                );
              }}
              description={description}
              key={id}
              media={mediaUrl}
              mediaAlt={mediaAlt}
              size="lg"
              title={title}
              variant="critical"
            />
          );
        },
      )}
    </>
  );
};

export default injectIntl(HostHubPausedListingsItem);
